import { brand, neutrals, social, alert } from 'src/theme/colors';
import { StyleSheet } from 'react-native';

export const style = StyleSheet.create({
  text: {
    alignItems: 'center',
    gap: 8,
  },
  description: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
    maxWidth: 350,
  },
  buttonPrimary: {
    width: 200,
    borderRadius: 25,
    paddingVertical: 11,
    backgroundColor: brand.main.water,
    shadowColor: brand.main.variations['lighterWater-2'],
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowRadius: 4,
  },
  buttonPrimaryDisabled: {
    backgroundColor: neutrals.neutralGrays.dust,
    shadowOpacity: 0,
  },
  buttonPrimaryText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    textAlign: 'center',
    color: neutrals.white,
  },
  buttonPrimaryTextDisabled: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    textAlign: 'center',
    color: neutrals.neutralGrays.ash,
  },
  buttonSecondary: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 305,
    borderRadius: 100,
    paddingVertical: 13,
    paddingHorizontal: 30,
    gap: 10,
    borderWidth: 1,
    backgroundColor: neutrals.white,
    borderColor: neutrals.neutralGrays.snow,
    shadowColor: neutrals.neutralGrays.dust,
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowRadius: 4,
  },
  buttonSecondaryText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    color: social.googlePhotos,
  },
  textError: {
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: alert.alertRed,
  },
  textErrorBold: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
    color: alert.alertRed,
  },
  googlePhotoIconSmall: {
    width: 20,
    height: 20,
  },
  modalContainer: {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  wrapperContainer: {
    gap: 24,
    alignItems: 'center',
    flexDirection: 'column',
  },
  container: {
    marginHorizontal: 32,
    marginBottom: 40,
    backgroundColor: neutrals.coldGrays.ice,
    borderWidth: 3,
    borderStyle: 'dashed',
    borderColor: brand.main.variations['lighterWater-2'],
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
    gap: 39,
    paddingVertical: 32,
    flex: 1,
  },
  content: {
    alignItems: 'center',
    gap: 24,
    paddingHorizontal: 32,
  },
  googlePhotoIcon: {
    width: 80,
    height: 80,
  },

  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 28,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  errorWrapper: {
    height: 80,
    flexDirection: 'row',
  },
});
